export default __webpack_public_path__ + "static/media/brian.0878634c.svg";